// 此文件不要动
export const nameComponentObj = {
  "financeSupplierManage": {
    name: "financeSupplierManage",
    label: "财务管理/供应商管理",
    permissionIdentification: "finance:supplier:list", // 权限标识
    component: () => import(/* webpackChunkName: "financeModule" */"@/views/finance/supplier/index.vue")
  },
  "financeCustomerManage": {
    name: "financeCustomerManage",
    label: "财务管理/客户管理",
    permissionIdentification: "finance:customer:list", // 权限标识
    component: () => import(/* webpackChunkName: "financeModule" */"@/views/finance/customer/index.vue")
  },
  "financeBillManage": {
    name: "financeBillManage",
    label: "财务管理/账单管理",
    permissionIdentification: "finance:bill:list", // 权限标识
    component: () => import(/* webpackChunkName: "financeModule" */"@/views/finance/bill/index.vue")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  financeBillCreate: {
    label: "财务管理/账单管理/新增账单",
    value: "finance:bill:create"
  },
  financeSupplierCreate: {
    label: "财务管理/供应商管理/新增供应商",
    value: "finance:supplier:create"
  },
  financeSupplierDelete: {
    label: "财务管理/供应商管理/删除供应商",
    value: "finance:supplier:delete"
  },
  financeSupplierUpdate: {
    label: "财务管理/供应商管理/更新供应商",
    value: "finance:supplier:update"
  },
  financeSupplierRead: {
    label: "财务管理/供应商管理/查看供应商",
    value: "finance:supplier:read"
  },
  financeSupplierStatus: {
    label: "财务管理/供应商管理/修改状态",
    value: "finance:supplier:status"
  },
  financeCustomerCreate: {
    label: "财务管理/客户管理/新增客户",
    value: "finance:customer:create"
  },
  financeCustomerDelete: {
    label: "财务管理/客户管理/删除客户",
    value: "finance:customer:delete"
  },
  financeCustomerUpdate: {
    label: "财务管理/客户管理/更新客户",
    value: "finance:customer:update"
  },
  financeCustomerRead: {
    label: "财务管理/客户管理/查看客户",
    value: "finance:customer:read"
  },
  financeCustomerStatus: {
    label: "财务管理/客户管理/修改状态",
    value: "finance:customer:status"
  },
  financePayRecordList: {
    label: "财务管理/账单管理/收付款记录",
    value: "finance:payRecord:list"
  },
  financeAddPayRecord: {
    label: "财务管理/账单管理/添加收付款记录",
    value: "finance:payRecord:add"
  }
}